import {REGISTER_REQUEST, REGISTER_VALIDATE, REGISTER_NOT_VALIDATE, REGISTER_COMPLETE, REGISTER_FAIL} from "../store/config";

const registerInit = {
	isFetching: false,
	data: {},
	modalities:[],
	state: 'close',
	style: 'is-one-third',
	action: undefined,
	error: undefined,
	status: undefined,
	message: undefined,
	timestamp: undefined
}

//is-8 para registro validado
//is-one-third para validar
//is-9 para registro nuevo

const register = (state = registerInit, action) => {
	switch (action.type) {
		case REGISTER_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				status: action.status,
				timestamp: action.timestamp
			}
		case REGISTER_VALIDATE:
			return {
				...state,
				isFetching: action.isFetching,
				status: action.status,
				data: action.payload.data,
				modalities: action.payload.modalities,
				state: action.payload.state,
				action: action.payload.action,
				style: action.payload.style,
				error: action.error,
				timestamp: action.timestamp
			}
		case REGISTER_NOT_VALIDATE:
			return {
				...state,
				isFetching: action.isFetching,
				status: action.status,
				message: action.message,
				data: action.payload.data,
				modalities: action.payload.modalities,
				state: action.payload.state,
				action: action.payload.action,
				style: action.payload.style,
				error: action.error,
				timestamp: action.timestamp
			}
		case REGISTER_COMPLETE:
			return {
				...state,
				isFetching: action.isFetching,
				status: action.status,
				message: action.message,
				data: action.payload.data,
				modalities: action.payload.modalities,
				state: action.payload.state,
				action: action.payload.action,
				style: action.payload.style,
				error: action.error,
				timestamp: action.timestamp
			}
		case REGISTER_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				status: action.status,
				message: action.message,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
}

export default register;


// WEBPACK FOOTER //
// ./src/reducers/register.js